import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './Document.css';

class Document extends Component {
    render() {
        const docIcon = process.env.BASE_URL + "images/app/doc.png";
        const downloadIco = process.env.BASE_URL + "images/app/download.png";
        const viewIco = process.env.BASE_URL + "images/app/view.png";
        var docLink = "";
        if (this.props.type == "1") {
            {/*eslint-disable-next-line react/jsx-no-target-blank*/ }
            docLink = <a href={process.env.BASE_URL + this.props.path} target="_blank">
                <img alt="Download" title="Download" src={downloadIco} className="imgdownload" />
            </a>
        }
        else {
            docLink = <Link to={this.props.path}>
                <img alt="View" title="View" src={viewIco} className="imgdownload" />
            </Link>
        }

        return (
            <div className="smallBox">
                <div className="smallBoxIcon">
                    <img src={docIcon} className="imgDoc" />
                </div>
                <div className="smallBoxText">
                    {this.props.DocName}
                </div>
                <div className="smallBoxOption">
                    {docLink}
                </div>
            </div>
        )
    }
}

Document.propTypes = {
    path: PropTypes.string,
    type: PropTypes.string,
    DocName: PropTypes.string
}

export default Document;